// extracted by mini-css-extract-plugin
module.exports = {"bannerButton":"styles_bannerButton__36Hn9","flex":"styles_flex__iK4L7"};